import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import LLMMarkdownSection from 'llm/markdown/LLMMarkdownSection';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import * as Colors from 'ui-library/Colors';

export interface SQLAssistantSidePanelProps {
  markdown: string;
}

export default function SQLAssistantSidePanel(props: SQLAssistantSidePanelProps): JSX.Element {
  const [collapsed, setCollapsed] = React.useState(false);

  return (
    <div className={css(collapsed ? styles.collapsedSidePanel : styles.openSidePanel)}>
      <Button
        size={ButtonSize.MINI}
        buttonStyle={ButtonStyle.TRANSPARENT}
        icon={collapsed ? 'chevron-right' : 'chevron-left'}
        onClick={() => {
          setCollapsed(!collapsed);
        }}
      />

      <div className={css(styles.content)}>
        {!collapsed && (
          <>
            <h3 className={css(styles.header)}>Explanation</h3>
            <LLMMarkdownSection markdown={props.markdown} />
          </>
        )}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  collapsedSidePanel: {
    borderLeft: `1px solid ${Colors.GRAY_LIGHT}`,
    overflow: 'hidden',
    paddingBottom: 8,
    transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    width: 24,
  },
  openSidePanel: {
    borderLeft: `1px solid ${Colors.GRAY_LIGHT}`,
    overflow: 'hidden',
    paddingBottom: 8,
    paddingLeft: 8,
    transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    width: 320,
  },
  content: {
    maxHeight: 568,
    overflowY: 'auto',
    padding: 8,
    width: 312, // Full content width (320 - 8px padding)
    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    transform: 'translateX(0)',
  },
  header: {
    fontSize: 14,
    fontWeight: 600,
    margin: 0,
    marginBottom: 8,
  },
});
